import { useContext } from 'react';

import { SelectedParticipantContext } from '../../components/SelectedParticipantProvider';

const useSelectedParticipantContext = () => {
  const context = useContext(SelectedParticipantContext);

  if (typeof context === 'undefined') {
    throw new Error('SelectedParticipantContext must be used within SelectedParticipantProvider');
  }

  return { ...context } as const;
};

export default useSelectedParticipantContext;
